import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  Renderer2,
} from '@angular/core';
import { NavInterface } from '@shared/interfaces/nav.interface';

@Directive({
  selector: 'a[appActiveRoute]',
  standalone: true,
})
export class ActiveRouteDirective implements AfterViewInit {
  @Input() subMenus: NavInterface[];

  activeClass = 'route-active';
  constructor(
    private readonly el: ElementRef<HTMLLinkElement>,
    private readonly render2: Renderer2
  ) {}

  ngAfterViewInit(): void {
    const nativeElement = this.el.nativeElement;
    const itemRoute = nativeElement.href;

    const currentUri = location.origin + location.pathname;

    if (this.samepath(currentUri, itemRoute) || this.hasActiveSubmenu()) {
      this.render2.addClass(nativeElement, this.activeClass);
    } else {
      this.render2.removeClass(nativeElement, this.activeClass);
    }
  }

  private hasActiveSubmenu(): boolean {
    if (this.subMenus) {
      const pathname = location.pathname;
      for (const item of this.subMenus) {
        if (this.samepath(pathname, item.route)) {
          return true;
        }
      }
    }
    return false;
  }

  private samepath(currentUri, itemRoute): boolean {
    return (
      currentUri.includes(itemRoute) && currentUri.length - itemRoute.length < 2
    );
  }
}
